import React from 'react'

//
import { HeroHomeBlockTwo } from '../../../storybook'
//Block > Feature Cards
const BlockHeroHomeTwo = ({
  data: { preface, title, description, background, featureCardBlocks = [], gradient }
}) => {
  const featureCards = featureCardBlocks
  return (
    <>
      <HeroHomeBlockTwo
        preface={preface}
        title={title}
        description={description}
        background={background}
        featureCards={featureCards}
        gradient={gradient}
      />
    </>
  )
}

export default BlockHeroHomeTwo
